import { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function SpecFilters({ category, sp, setSp }) {
  const [groups, setGroups] = useState([]);
  useEffect(() => { if (category) api.get("/filters", { params: { category } }).then((r) => setGroups(r.data)); else setGroups([]); }, [category]);
  const cur = Object.fromEntries(sp.getAll("spec").map((s) => { const [k, v] = s.split(/:(.*)/s); return [k, v.split("|")]; }));
  const toggle = (k, v) => {
    const vals = cur[k]?.includes(v) ? cur[k].filter((x) => x !== v) : [...(cur[k] || []), v];
    const n = new URLSearchParams(sp);
    n.delete("spec");
    Object.entries({ ...cur, [k]: vals }).forEach(([kk, vv]) => vv.length && n.append("spec", `${kk}:${vv.join("|")}`));
    setSp(n);
  };
  if (!groups.length) return null;
  return (
    <div className="space-y-5" data-testid="spec-filters">
      {groups.map((g) => (
        <div key={g.key}>
          <p className="text-xs uppercase tracking-wider text-slate-500 mb-2">{g.key === "Storage" ? "Storage (ROM)" : g.key === "Screen" ? "Screen size" : g.key === "Battery" ? "Battery capacity" : g.key}</p>
          <div className="flex flex-wrap gap-1.5">
            {g.values.map((v) => {
              const on = cur[g.key]?.includes(v);
              return <button key={v} data-testid={`spec-${g.key.toLowerCase().replace(/\s+/g, "-")}-${String(v).replace(/[^a-zA-Z0-9]+/g, "")}`} onClick={() => toggle(g.key, v)}
                className={`px-3 py-1.5 rounded-full text-xs border transition-colors ${on ? "bg-[#ff5500] border-[#ff5500] text-white" : "border-white/10 text-slate-300 hover:border-white/30"}`}>{v}</button>;
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
